/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { Component } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import { PopModal } from './components/PopModal';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Logout from './components/Logout';
import ConsoleLayout from './components/ConsoleLayout';
import Dashboard from './components/Dashboard';
import ForgotPassword from './components/ForgotPassword';
import SetPassword from './components/SetPassword';
import E404 from './components/E404';
import { ImageViewCom } from './components/ImageView';
import Globals from './shared/Globals';
import { loadLang, pullCurrentLang } from './shared/GLang';
import Menu from './components/Menu';
import { Layout } from './components/Layout';
import PaymentMethod from './components/Payment/PaymentMethod';
import PaymentLayout from './components/Payment/PaymentLayout';
import Payment from './components/Payment/Payment';
import Success from './components/Payment/Success';
import Home from './components/Home';

export const AppGlobal = {
    setLang() { }
};

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: 'es',
            serverUrl: Globals.serverUrl
        };
        this.setLang = this.setLang.bind(this);
        AppGlobal.setLang = this.setLang;
    }

    async componentDidMount() {
        this.init();
        await this.loadCardinalAsync();
    }

    init = (serverUrl) => {
        if (serverUrl) {
            Globals.serverUrl = serverUrl;
            this.setState({ serverUrl: serverUrl });
        }
        loadLang(() => {
            pullCurrentLang(lang => {
                this.setState({ lang: lang });
            });
        });
    }

    setLang(lang) {
        Globals.setLang(lang);
        this.setState({ lang: lang });
    }

    loadCardinalAsync = async () => {

        let env = await Globals.fetchServerEnvAsync();


        let script = document.createElement('script');
        /*
        if(env.sandbox) {
            console.log('Using songbird sandbox');
            script.src = 'https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js';
        }
        else
        */
        script.src = 'https://songbird.cardinalcommerce.com/edge/v1/songbird.js';
        script.async = true;
        script.onload = () => {
            console.log('Cardinal loaded');
        };
        document.head.appendChild(script);
    }



    render() {
        return (<>
            <PopModal />
            <ImageViewCom />
            <ToastContainer position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light" />
            <BrowserRouter lang={this.state.lang}>
                <Routes>
                    <Route path="/" element={<Layout />}>

                        <Route path="/gateway/:sid" element={<PaymentLayout />}>
                            <Route index element={<PaymentMethod />} />
                            <Route path="payment/:method" element={<Payment />} />
                            <Route path="success" element={<Success />} />
                        </Route>
                        <Route path="/login" element={<Login />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password/:code" element={<SetPassword />} />
                        <Route path="/console" element={<ConsoleLayout lang={this.state.lang} />}>
                            <Route index element={<Dashboard lang={this.state.lang} />} />
                            <Route path="menu" element={<Menu />} />
                            <Route path="*" element={<E404 />} />
                        </Route>
                        <Route index element={<Home />} />
                        <Route path="*" element={<E404 />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </>
        );
    }
}
